exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.jira-issues ul{padding:0\n}\n.jira-issues li{list-style-type:none;margin:2px 2px 2px 0;text-align:start\n}\n.jira-issues .jira-issue{cursor:default\n}\n.jira-issues .jira-issue img{margin-left:6px;margin-right:10px;vertical-align:middle\n}\n.jira-issues .jira-issue .jira-type{cursor:pointer\n}\n.jira-new.flex{padding-left:0!important\n}\n.jira-new.flex .v-btn{height:30px;margin-left:0;width:30px\n}\n.jira-new-input{min-width:220px\n}\n.jira-new-input label{font-size:14px\n}", ""]);

// exports
